import { COMPANY } from '../schema';
import { database } from '../index';

const company = database.collections.get(COMPANY);

export const findCompanyByID = async (id) => await company.find(id);


